import { SectionContainer } from "@/components/SectionContainer/SectionContainer";
import style from "./KanbanColumn.module.css";
import { Box, Typography } from "@mui/material";
import { KanbanCardComponent } from "../KanbanCard";
import Avatar from '@mui/material/Avatar';
import { KanbanCardSkeleton } from "../KanbanCardSkeleton";
import { useInifiteScroll } from "@/services/inifniteScroll/InifiniteScroll";
import { useEffect, useState } from "react";
import { LeadStageEnum } from "@/interfaces/RegisterLead";
import attendanceApi from "@/services/api/attendance";
import { useLeads } from "@/pages/leads/context/leadContext";
import { set } from "date-fns";
import { leadApi } from "@/services/api/leads";
import { useKanbanSearch } from "../kanbanSearchContext/KanbanSearchContext";
import { safeJsonParse } from "@/utils/safeJsonParse";
interface KanbanColumn {
    title: string;
    icon?: JSX.Element;
    headerColor: string;
    // atendancesListSection: any[];
    titleColor?: string;
    amount?: any;
    carregando?: boolean;
    // lastElementRef?: any;
    stage: string;
    // searchTerm? : string;
    // selectedOptionAttendant?: string[];
    // selectedOptionCreatedAt?: string; //Hoje, Esta semana, Este mês
}

const leadsStage = [LeadStageEnum.EM_CONTATO, LeadStageEnum.NAO_CLASSIFICADO, LeadStageEnum.PERDIDO]

export function KanbanColumnComponent({ title, headerColor, titleColor, icon, amount, stage}: KanbanColumn) {

    const isAtendimento = !(Object.values(LeadStageEnum) as string[]).includes(stage)

    const leadContext = useLeads();
    const { searchTerm, selectedOptionAttendant, selectedOptionCreatedAt, startDate, endDate } = useKanbanSearch();

    const [pagina, setPagina] = useState(1)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [quantidadePorPagina, setQuantidadePorPagina] = useState(10)
    const [gotAllData, setGotAllData] = useState(false)
    const [isMounted, setIsMounted] = useState(false)
    const [total, setTotal] = useState(0)
    const [carregando, setCarregando] = useState(true)

    const [attendancesListSection, setAttendancesListSection] = useState<any[]>([])
    const storageAtendente = localStorage.getItem("attendant");
    const atendente = storageAtendente ? safeJsonParse(storageAtendente) : null; 

    async function getAtendimentos(paginaInput? : number, quantidadeInput? : number, force? : boolean, givenList? : any[]) {

        setCarregando(true)

        if(gotAllData && !force){
            setCarregando(false)
            return;
        } 

        const responseAtendimentos = await attendanceApi.getByEstadoKanban({
            estado: stage, 
            arquivamento: leadContext.filterArchived, 
            searchTerm : searchTerm ?? undefined, 
            atendentes : selectedOptionAttendant ?? undefined, 
            criadoEm : selectedOptionCreatedAt ?? undefined, 
            startDate: startDate ?? undefined,
            endDate: endDate ?? undefined,
            pagina: paginaInput ?? pagina, 
            quantidade: quantidadeInput ?? quantidadeInput,
            atendente_id: atendente.id
        });

        let dataAtendimentos = responseAtendimentos.data.atendimentos.atendimentos;
        setTotal(responseAtendimentos.data.atendimentos.total ?? 0)

        // console.log("dataAtendimentos", stage, dataAtendimentos)

        let tmpList : any[] = givenList ?? attendancesListSection;
        console.log("primeiro tmpList: ", stage, tmpList)

        if(!dataAtendimentos){
            return;
        };

        if(dataAtendimentos.length === 0){
            if(tmpList.length === 0){
                setAttendancesListSection([])
                return;
            }
            setGotAllData(true)
            setCarregando(false)
            return;
        }

        dataAtendimentos.forEach((element : any) => {
            element.nome = element.Cliente.nome
            element.estagioAtualizadoEm = element.atualizadoEm
            element.attendanceState = element.estado 
        });


        console.log("attendancesListSection", attendancesListSection)

        dataAtendimentos.forEach((element : any) => {
            // if(attendancesListSection.find((el : any) => el.id !== element.id))return;
            tmpList.push(element) 
        });

        setAttendancesListSection(tmpList)

        console.log("tmpList", tmpList)
        setCarregando(false)

  }

  async function getLeads(paginaInput? : number, quantidadeInput? : number, force? : boolean, givenList? : any[]) {

    setCarregando(true)

    if(gotAllData && !force){
        setCarregando(false)
        return;
    } 

    const responseLeads = await leadApi.getByEstagio({
        estagio: stage, 
        arquivamento: leadContext.filterArchived, 
        searchTerm : searchTerm ?? undefined, 
        startDate: startDate ?? undefined,
        endDate : endDate ?? undefined,
        atendentes: selectedOptionAttendant ?? undefined, 
        criadoEm : selectedOptionCreatedAt ?? undefined, 
        pagina : paginaInput, 
        quantidade : quantidadeInput
    });

    if(!responseLeads.data.leads){
        return;
    }

    let tmpList : any[] = givenList ?? attendancesListSection;;

    const dataLeads = responseLeads.data.leads
    setTotal(responseLeads.data.total)

    if(dataLeads.length === 0){
        if(tmpList.length === 0){
            setAttendancesListSection([])
            return;
        }
        setGotAllData(true) 
        setCarregando(false)
        return;
    }



    dataLeads.forEach((element : any) => {
        // if(attendancesListSection.find((el : any) => el.id === element.id)) return;
        tmpList?.push(element)
    });

    setAttendancesListSection([...tmpList])

    setCarregando(false)

  }

    const loadMoreAttendances = async () => {
        if(isLoadingMore) return;

        setIsLoadingMore(true)

        const paginaAtual = pagina + 1
        await getAtendimentos(paginaAtual, quantidadePorPagina)
        setPagina(paginaAtual)
        setIsLoadingMore(false)

    }

    const loadMoreLeads = async () => {
        if(isLoadingMore) return;

        setIsLoadingMore(true)

        const paginaAtual = pagina + 1
        await getLeads(paginaAtual, quantidadePorPagina)
        setPagina(paginaAtual)
        setIsLoadingMore(false)
    }

    let lastElementRef = isAtendimento? useInifiteScroll(loadMoreAttendances) : useInifiteScroll(loadMoreLeads)

    useEffect(() => {
        if(isAtendimento)
            getAtendimentos(pagina, quantidadePorPagina).then(() => setIsMounted(true))
        else
            getLeads(pagina, quantidadePorPagina).then(() => setIsMounted(true))

        setTimeout(() => {
            setCarregando(false)
        }, 100)

    }, [])

    useEffect(() => {

        if(!isMounted) return;

        setGotAllData(false)
        setPagina(1)
        if(isAtendimento)
            getAtendimentos(1, quantidadePorPagina, true, [])
        else
            getLeads(1, quantidadePorPagina, true, [])

        leadContext.setReloadList(!leadContext.reloadList)

        console.log("ultimo useEffect")
    }, [selectedOptionAttendant, selectedOptionCreatedAt, searchTerm, leadContext.filterArchived, startDate, endDate])


    useEffect(() => {
        console.log("useEffect attendancesListSection", stage)
        console.log("attendancesListSection USE STATE", attendancesListSection)
    }, [attendancesListSection])


    return (
        <SectionContainer className={style.section} noMargin={true}>
            <Box className={style.headerColumn} style={{ backgroundColor: headerColor }}>
                {icon && <Box marginRight={1} style={{ color: titleColor || 'white' }}>{icon}</Box>}
                <Typography className={style.tittle_column} style={{ color: titleColor || 'white' }}>
                    {title}
                </Typography>
                <Avatar className={style.avatar_number}>
                    <h4 style={{ color: headerColor }}>{total}</h4>
                </Avatar>
            </Box>
            <Box className={style.bodyColumn}>
                {
                    !isMounted ? 
                        <KanbanCardSkeleton />
                    :
                    attendancesListSection.map((lead, index) => {
                        return(
                            <KanbanCardComponent
                                key={lead.id || index}
                                lead={lead}
                                columnTitle={title}
                                ref_={index === attendancesListSection.length-1 ? lastElementRef : null}
                                carregando={carregando}
                            />
                        )
                    })
                }    
            </Box>
        </SectionContainer>
    );
}
